import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import contractorTerminationService from "../../services/contractorTerminationService";


export const fetchContractorTerminations = createAsyncThunk(
  "contractorTermination/fetchContractorTerminations",
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await contractorTerminationService.GetContractorTerminations(employeeId);
      const body = response?.data;
      if (Array.isArray(body)) return body;

      const statusCode = body?.StatusCode ?? response?.StatusCode;
      // No history yet is not an error — the contract simply has no changes.
      if (statusCode === 404 || /no\s*(data|record)/i.test(body?.Message || "")) return [];
      if (statusCode !== undefined && statusCode !== 200) {
        throw new Error(body?.Message || "Failed to load contract history.");
      }
      return Array.isArray(body?.ResultSet) ? body.ResultSet
        : Array.isArray(body?.Result) ? body.Result
        : [];
    } catch (error) {
      if (error.response?.status === 404) return [];
      return rejectWithValue(
        error.response?.data?.Message || error.message || "Failed to load contract history."
      );
    }
  }
);

const initialState = {
  employeeId: null,   // whose history `terminations` holds
  terminations: [],
  loading: false,
  error: null,
};

const contractorTerminationSlice = createSlice({
  name: "contractorTermination",
  initialState,
  reducers: {
    clearContractorTerminations(state) {
      state.employeeId = null;
      state.terminations = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContractorTerminations.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        // Drop the previous employee's rows so they never flash on screen.
        if (String(state.employeeId) !== String(action.meta.arg)) state.terminations = [];
        state.employeeId = action.meta.arg;
      })
      .addCase(fetchContractorTerminations.fulfilled, (state, action) => {
        if (String(state.employeeId) !== String(action.meta.arg)) return; // a newer request won
        state.loading = false;
        state.terminations = action.payload || [];
      })
      .addCase(fetchContractorTerminations.rejected, (state, action) => {
        if (String(state.employeeId) !== String(action.meta.arg)) return;
        state.loading = false;
        state.terminations = [];
        state.error = action.payload || "Failed to load contract history.";
      });
  },
});

export const { clearContractorTerminations } = contractorTerminationSlice.actions;
export default contractorTerminationSlice.reducer;